import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { message } from 'antd';
import { MSG } from 'commons/constants';

const useManagementClosing = (year: string) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [closeList, setCloseList] = useState<any[]>();
  const [detailList, setDetailList] = useState<any[]>();
  
  /* ======================================================
   * hooks
   * ====================================================== */

  const { isLoading, refetch } = useQuery(
    [endpoints.management.close, [year]],
    () =>
      fetcher.management.postClose({
        searchValue: year,          
      }),
    {
      onSuccess: (res: ManagementListResDto) => {
        switch (res.code) {
          case 200:
            setCloseList(res.result?.list);
            setDetailList([]);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  const { mutate: historyDetail } = useMutation(
    [endpoints.management.closeDetail],
    fetcher.management.postCloseDetail,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            setDetailList(res.result?.list);
            break;
          default:
            break;
        }
      },
    },
  )

  const { mutate: closeUpdate, isSuccess: updateSuccess } = useMutation(
    [endpoints.management.closeUpdate],
    fetcher.management.postCloseUpdate,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_SAVE, 1);
            refetch();
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )  

  return { closeList, detailList, refetch, historyDetail, closeUpdate, updateSuccess };
};

export default useManagementClosing;
